// components/BannerCarousel.jsx
import { useState } from "react";
import { Carousel } from "react-bootstrap";
import imageBanner from "../../../__params/tab-pages/home/tab-bannercarousel";
import "../../../assets/css/bannercarousel.css";

const BannerCarousel = () => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <Carousel
      // slide="true"
      activeIndex={index}
      onSelect={handleSelect}
      interval={5000} // Changement toutes les 5 secondes
      pause="hover" // Pause au survol
      fade="true" // Effet de fondu (optionnel)
      className="custom-carousel"
    >
      {imageBanner.map((slide) => (
        <Carousel.Item key={slide.id}>
          <img
            className="d-block w-100"
            src={slide.image}
            alt={slide.title}
            style={{ height: "300px", objectFit: "cover" }}
          />
          <Carousel.Caption className="rounded">
            <h3>{slide.title}</h3>
          </Carousel.Caption>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default BannerCarousel;
